export const SKIPFLYTHROUGH_CONTENT = {
  skipMessage: 'SKIP >',
}
